import { render, staticRenderFns } from "./MarketingCampaignCreate.vue?vue&type=template&id=02bea584&"
import script from "./MarketingCampaignCreate.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports